<table [class]="tableClass">
  <tbody>
    <tr *ngFor="let row of table">
      <th>
        <span
          *ngIf="row?.icon"
          [matTooltip]="row.iconTooltip"
          [inlineSVG]="row.icon"
          class="center"
          matTooltipPosition="above"
        ></span>
        <span
          matTooltip="{{ row.tooltip ? row.tooltip : '' }}"
          matTooltipPosition="above"
        >
          {{ row.header }}
        </span>
      </th>
      <td [attr.data-testid]="'table-data-'.concat(row.header.toLowerCase().split(' ').join('-'))">
        <ng-container *ngIf="row.value; else dash">
          <pre *ngIf="row.type === 'preformatted'">{{ row.value }}</pre>

          <ul *ngIf="row.type === 'list'">
            <li *ngFor="let item of row.value">{{ item }}</li>
          </ul>

          <ng-container *ngIf="row.type === 'tags'">
            <ng-container *ngIf="row.value.length; else noTags">
              <span class="tag" [ngClass]="toKebabCase(item)" *ngFor="let item of row.value">{{ item }}</span>
            </ng-container>
            <ng-template #noTags>
              <p class="empty-tag">–</p>
            </ng-template>
          </ng-container>

          <ng-container *ngIf="row.type === 'href'">
            <a [href]="row.url" target="_blank">{{ row.value }}</a>
          </ng-container>

          <!-- link is a separate type because href is used elsewhere without routerLink -->
          <ng-container *ngIf="row.type === 'link'">
            <a [routerLink]="row.url" target="_blank">
              {{ row.value }}
            </a>
          </ng-container>

          <ng-container *ngIf="row.type === 'obfuscated'">
            {{ row.value }}
            <ng-container *ngIf="row.obfuscated; else unobfuscated">
              <button (click)="row.callback()" class="toggle-obfuscate-button" inlineSVG="/assets/icons/eye.svg"></button>
            </ng-container>
            <ng-template #unobfuscated>
              <button (click)="row.callback()" class="toggle-obfuscate-button" inlineSVG="/assets/icons/eye-off.svg"></button>
            </ng-template>
          </ng-container>

          <ng-container *ngIf="!row.type || row.type === 'string'">{{ row.value }}</ng-container>
        </ng-container>
        <ng-template #dash> – </ng-template>
      </td>
    </tr>
  </tbody>
</table>
